import { Button, Dialog, DialogContent, Divider, IconButton, Stack, useMediaQuery, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next"
import { useCallback, useState } from "react"
import {
  Close as CloseIcon,
  ArrowBack as ArrowBackIcon
} from '@mui/icons-material'

import { defaultFunction, getCompany } from "../../utilities/utilities"
import { removeDatefromDateTime } from "../../utilities/FormatDate"
import PrintTicketModal from "../PrintTicketModal/PrintTicketModal"
import { connect } from "react-redux"
import { DEFAULT_AUTOCOMPLETE } from "../../../variables"
import IDPhotoDialog from "../IDPhotoDialog/IDPhotoDialog"

function DetailDialog(props) {
  const {
    open = false,
    ask_visit_identification = false,
    custom_visit_identification_label = '',
    ask_visit_laptop = false,
    ask_visit_comes_from = false,
    companies = [],
    onClose = defaultFunction,
    item = {},
  } = props

  const { t } = useTranslation()
  const theme = useTheme()
  const isLarge = useMediaQuery(theme.breakpoints.up('md'))
  const identificationLabel = custom_visit_identification_label || t('Identification')
  const [openIdentificationPhoto, setOpenIdentificationPhoto] = useState(false)
  const [openPrintTicket, setOpenPrinTicket] = useState(false)

  const {
    identification = '',
    destination = DEFAULT_AUTOCOMPLETE,
    company_id = -1,
    comes_from = '',
    entry_time = '',
    exit_time = '',
    card_number = '',
    notes = '',
    has_laptop = false,
    laptop_serie = ''
  } = item

  const getSelectedItemFullName = useCallback(() => {
    const {
      first_name = '',
      last_name_one = '',
      last_name_two = ''
    } = item

    return `${first_name} ${last_name_one} ${last_name_two}`
  }, [item])

  return (
    <Dialog
      fullWidth={true}
      maxWidth="sm"
      open={open}
      fullScreen={!isLarge}
      onClose={onClose}
      aria-labelledby="responsive-dialog-title">
      <DialogContent className="dialog-info-content">
        <Stack gap={2} alignItems="center">
          <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
            <Stack direction="row" alignItems="center" gap={1}>
              <IconButton
                aria-label="close"
                onClick={onClose}
              >
                <ArrowBackIcon color='primary' />
              </IconButton>
              <label>
                {
                  card_number ?
                    t('Card x in use', { card_number }) :
                    t('Visit')
                }
              </label>
            </Stack>
            <IconButton
              aria-label="close"
              onClick={onClose}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider sx={{ width: '100%' }} />
          <Stack className="detail-info" gap={2}>
            {ask_visit_identification && <label>{identificationLabel}: <span>{identification}</span></label>}
            <label>{t('name')}: <span>{getSelectedItemFullName()}</span></label>
            <label>{t('go to')}: <span>{destination.name || getCompany(company_id, companies)}</span></label>
            {ask_visit_comes_from && <label>{t('comes from')}: <span>{comes_from}</span></label>}
            <label>{t('Entry time')}: <span>{removeDatefromDateTime(entry_time)}</span></label>
            <label>{t('Exit time')}: <span>{exit_time ? removeDatefromDateTime(exit_time) : t('unregistered')}</span></label>
            {card_number && <label>{t('Card')}: <span>{card_number}</span></label>}
            {ask_visit_laptop && <label>{t('Laptop')}: <span>{has_laptop && laptop_serie ? laptop_serie : t('unregistered')}</span></label>}
            <label>{t('Notes')}: <span>{notes ? notes : t('nothing')}</span></label>
          </Stack>
          <Stack spacing={2} justifyContent="center">
            {item.credential_photo?.id &&
              <Button
                size="large"
                sx={{ width: '469px' }}
                variant="outlined"
                onClick={() => setOpenIdentificationPhoto(true)} >
                {t("View identification photo")}
              </Button>
            }
            <Button
              size="large"
              sx={{ width: '469px' }}
              variant="outlined"
              onClick={() => setOpenPrinTicket(true)} >
              {t("View visitor sticker")}
            </Button>
            <Button
              size="large"
              sx={{ width: '469px' }}
              variant="contained"
              color="primary"
              onClick={onClose} >
              {t('accept')}
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
      <PrintTicketModal
        open={openPrintTicket}
        setOpen={setOpenPrinTicket}
        item={item}
      />
      {item.credential_photo?.id &&
        <IDPhotoDialog
          open={openIdentificationPhoto}
          setOpen={setOpenIdentificationPhoto}
          onClose={() => setOpenIdentificationPhoto(false)}
          credential_photo={item.credential_photo}
        />
      }
    </Dialog>
  )
}

const mapStateToProps = state => {
  return {
    ask_visit_comes_from: state.profile.ask_visit_comes_from,
    ask_visit_identification: state.profile.ask_visit_identification,
    custom_visit_identification_label: state.profile.custom_visit_identification_label,
    ask_visit_laptop: state.profile.ask_visit_laptop,
    companies: state.profile.companies
  }
}

export default connect(mapStateToProps)(DetailDialog)